<template>
  <div>
    <StepTitle :value="title" class="mb-8" />

    <div>
      <div class="form-group" :class="{ 'form-group-invalid': hasErrors }">
        <div class="flex justify-between px-0.5">
          <label for="fast-project-name" class="text-body-color">{{ label }}</label>
          <span>{{ cleanedName.length }}&#8239;/&#8239;{{ maxLength }}</span>
        </div>
        <input
          id="fast-project-name"
          ref="input"
          v-model="name"
          name="project_name"
          class="form-control h-auto rounded-lg py-4"
          :class="{ 'is-invalid': hasErrors }"
          :placeholder="placeholder"
          type="text"
          autocomplete="off"
          tabindex="-1"
          :maxlength="maxLength + (name.length - cleanedName.length)"
          @keypress.enter.prevent="proceed"
        />
        <div v-if="hasErrors" class="invalid-feedback">
          Le titre de votre projet {{ mainStore.errors.name | toSentence }}.
        </div>
      </div>
    </div>

    <div class="info-bubble relative mt-6 flex rounded-lg border bg-white px-4 py-6 md:mt-12">
      <div v-if="mainStore.invitedProvider && invitedProviderProfileHTML">
        <div class="mb-5 text-xl font-medium text-dark">Votre annonce sera destinée en priorité à</div>
        <div v-html="invitedProviderProfileHTML"></div>
      </div>
      <template v-else-if="!mainStore.invitedProvider">
        <div class="lg:w-2/3" v-html="reassurance"></div>
        <img
          :src="require('./../assets/onboarding.png')"
          alt="Freelance disponible"
          class="absolute -right-16 -top-12 hidden w-64 lg:block"
        />
      </template>
    </div>

    <portal v-if="active" to="fast-footer">
      <StepNav :next-disabled="!completed" @goToNext="proceed" />
    </portal>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { STEPS, useMainStore } from '@/apps/fast/store'
import { UserProfileResource } from '@/apps/shared/resources'

export default {
  data: () => ({
    name: '',
    invitedProviderProfileHTML: null
  }),
  computed: {
    ...mapStores(useMainStore),
    active() {
      return this.mainStore.step === STEPS.name
    },
    title() {
      return this.mainStore.stepContent(STEPS.name).title
    },
    label() {
      return this.mainStore.stepContent(STEPS.name).label
    },
    placeholder() {
      return this.mainStore.stepContent(STEPS.name).placeholder || 'Ex : site e-commerce, application iPhone, refonte blog…'
    },
    reassurance() {
      return this.mainStore.stepContent(STEPS.name).reassurance
    },
    nameRemainingLength() {
      const count = this.maxLength - this.cleanedName.length
      return count >= 2 ? `${count} caractères restants` : `${count} caractère restant`
    },
    cleanedName() {
      return this.name.replace(/^\s+/, '').replace(/\s+/g, ' ')
    },
    minLength() {
      return this.mainStore.stepContent(STEPS.name).minimumLength || 3
    },
    maxLength() {
      return this.mainStore.stepContent(STEPS.name).maximumLength || 70
    },
    hasErrors() {
      return this.mainStore.errors.name?.length > 0
    },
    completed() {
      return this.cleanedName.length >= this.minLength
    },
    nextButtonClassList() {
      if (this.completed) {
        return ''
      } else {
        return 'disabled'
      }
    }
  },
  created() {
    if (this.mainStore.invitedProvider) this.fetchInvitedProviderProfile()
  },
  mounted() {
    if (!this.mainStore.project?.name) this.name = this.mainStore.prefilledProjectTitle || ''
  },
  methods: {
    enter() {
      if (!this.$root.isAndroid()) this.$refs.input.focus()
      this.$root.sendMatomoPageView('name')
    },
    proceed() {
      if (!this.completed) return

      this.mainStore.project = { name: this.cleanedName }
      this.mainStore.requestBody.project.name = this.cleanedName.trim()

      this.mainStore.goToNextStep()
    },
    fetchInvitedProviderProfile() {
      UserProfileResource.get({ slug: this.mainStore.invitedProvider.slug, html: 'true' }).then(response => {
        this.invitedProviderProfileHTML = response.body
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.info-bubble:before {
  content: '';
  width: 0px;
  height: 0px;
  position: absolute;
  border: 18px solid transparent;
  border-bottom: 18px solid rgb(222, 226, 230);
  left: 40px;
  top: -35px;
}

.info-bubble:after {
  content: '';
  width: 0px;
  height: 0px;
  position: absolute;
  border: 17px solid transparent;
  border-bottom: 17px solid #fff;
  left: 41px;
  top: -33px;
}
</style>
